import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Logo } from '../../interfaces/Logo';
import { Usuario } from '@app/base/interfaces';
import { environment } from '@environments/environment';
import { AuthenticationService } from '@app/base/services';
import { Router } from '@angular/router';

interface Centro {
    fondoColor: string;
    textoColor: string;
    texto: string;
    subtitulo: string;
}
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
    logoIzquierda?: Logo;
    logoDerecha?: Logo;
    centro?: Centro;
    height?: number;
    loginActivo!: boolean;
    usuario?: Usuario;

    constructor(
        private configService: ConfigService,
        private authentiticacionService: AuthenticationService,
        private router: Router
    ) {}

    ngOnInit(): void {
        let { header } = this.configService.config;
        this.logoIzquierda = header.logoIzquierda;
        this.logoDerecha = header.logoDerecha;
        this.centro = header.centro;
        this.height = header.height;
        this.loginActivo = environment.loginActivo;
        this.authentiticacionService.usuarioLogueado.subscribe({
            next: (usuario) => (this.usuario = usuario),
        });
    }

    logout() {
        this.authentiticacionService.logout();
        this.router.navigate(['/login']);
    }
}
